// src/components/DestinationWeddingFormModal.js
import React, { useState } from 'react';
import Modal from 'react-modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import emailjs from '@emailjs/browser';
import './DestinationWeddingFormModal.css';

Modal.setAppElement('#root');

const DestinationWeddingFormModal = ({ isOpen, onRequestClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    destination: '',
    guests: '',
    budget: '',
    date: null,
    weddingType: '',
    requirements: '',
    form_type: "Destination Wedding"
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [thankYouModal, setThankYouModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const templateParams = {
      ...formData,
      date: formData.date ? formData.date.toLocaleDateString() : '',
      form_type: "Destination Wedding"
    };

    emailjs.send('service_rkd3nje', 'template_t8nu1ry', templateParams, 'jb85tG8nJgXDnDBVa')
      .then(() => {
        setIsSubmitting(false);
        setThankYouModal(true);
        onRequestClose();
        setFormData({
          name: '',
          email: '',
          phone: '',
          city: '',
          destination: '',
          guests: '',
          budget: '',
          date: null,
          weddingType: '',
          requirements: '',
          form_type: "Destination Wedding"
        });
      })
      .catch((err) => {
        console.error('Error sending form:', err);
        setIsSubmitting(false);
        alert("Something went wrong. Please try again.");
      });
  };

  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={onRequestClose} className="wedding-form-modal" overlayClassName="modal-overlay">
        <button className="close-form-btn" onClick={onRequestClose}>×</button>
        <h2 className="form-title">💍 Plan My Destination Wedding</h2>
        <form onSubmit={handleSubmit} className="wedding-form">
          <input type="text" name="name" placeholder="Your Full Name" required value={formData.name} onChange={handleChange} />
          <input type="email" name="email" placeholder="Email Address" required value={formData.email} onChange={handleChange} />
          <input type="tel" name="phone" placeholder="Phone Number" required value={formData.phone} onChange={handleChange} />
          <input type="text" name="city" placeholder="City/Country of Residence" required value={formData.city} onChange={handleChange} />
          <input type="text" name="destination" placeholder="Preferred Wedding Destination" required value={formData.destination} onChange={handleChange} />
          <input type="number" name="guests" placeholder="Number of Guests" required value={formData.guests} onChange={handleChange} />
          <input type="text" name="budget" placeholder="Budget Range (e.g., ₹10-15L)" required value={formData.budget} onChange={handleChange} />

          <DatePicker
            selected={formData.date}
            onChange={(date) => setFormData(prev => ({ ...prev, date }))}
            placeholderText="Select Wedding Date"
            className="datepicker-input"
            required
          />

          <select name="weddingType" required value={formData.weddingType} onChange={handleChange}>
            <option value="">Type of Wedding</option>
            <option value="Beach Wedding">Beach Wedding</option>
            <option value="Palace Wedding">Palace Wedding</option>
            <option value="Mountain Wedding">Mountain Wedding</option>
            <option value="Resort Wedding">Resort Wedding</option>
          </select>

          <textarea
            name="requirements"
            placeholder="Additional Requirements (decor, photography, etc.)"
            value={formData.requirements}
            onChange={handleChange}
          ></textarea>

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </Modal>

      <Modal isOpen={thankYouModal} onRequestClose={() => setThankYouModal(false)} className="thankyou-modal" overlayClassName="modal-overlay">
        <div className="thank-you-box">
          <div className="checkmark">✅</div>
          <h3>Thank you!</h3>
          <p>We'll get in touch with you shortly.</p>
          <button onClick={() => setThankYouModal(false)}>Close</button>
        </div>
      </Modal>
    </>
  );
};

export default DestinationWeddingFormModal;
